import { useServiceData } from "../context/ServiceDataContext"
import MarketingSection1 from "../sections/MarketingSection1"
import MarketingSection2 from "../sections/MarketingSection2"
import MarketingSection3 from "../sections/MarketingSection3"
import { AwardsComponent } from "./Home"

const Marketing = () => {

    return (
        <>
            <AwardsComponent />
            <div className="min-h-screen w-full bg-white dark:bg-transparent relative z-10
    text-black dark:text-white">
                <MarketingSection1 />

                <MarketingSection2 />

                <div className='xl:h-[90vh] w-full relative z-30 overflow-hidden'>
                    <video autoPlay muted loop src="/videos/Clip1.webm" className='h-full w-full object-cover'></video>
                </div>

                <MarketingSection3 />
            </div>
        </>
    )
}

export default Marketing